import { CidrMask, isPathLookupMaskValid } from '@ipfabric/utils';
import { getIpType } from '@ipfabric/utils/ipUtils';
import type { HostToDefaultGWFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/HostToDefaultGWFormValues';
import { isMulticastAddress } from 'components/Graph/GraphSidePanel/GraphPathlookup/helpers/isMulticastAddress';
import type { FormikErrors } from 'formik';
import type { AppTranslations } from 'translations/translations';
import { isValidIpv4or6Address } from 'utils/formValidation/validations';

export const validateHostToDefaultGW =
  (msg: AppTranslations) =>
  (
    values: HostToDefaultGWFormValues,
  ): FormikErrors<HostToDefaultGWFormValues> => {
    const errors: FormikErrors<HostToDefaultGWFormValues> = {};

    if (!isValidIpv4or6Address(values.startingPoint)) {
      errors.startingPoint = 'Invalid IPv4 or IPv6 address or range';
    } else if (
      !isPathLookupMaskValid(
        values.startingPoint,
        CidrMask.hostMode[getIpType(values.startingPoint)],
      )
    ) {
      errors.startingPoint =
        msg.canvasGraph.graphSidePanel.pathlookup.validation.shortMask(
          CidrMask.hostMode[getIpType(values.startingPoint)],
        );
    }

    if (isMulticastAddress(values.startingPoint)) {
      errors.startingPoint =
        msg.canvasGraph.graphSidePanel.pathlookup.validation.multicastSource;
    }

    return errors;
  };
